import {spcExpliciteChoiceDecision} from './values';

export function getDefaultDecisions(components, conditionalVariantValues) {
	if (!components || !conditionalVariantValues) return {};

	// find features, that are visible in configurator
	const visibleFeatures = [].concat(...components.map(component => component.features)).filter(f => f.isVisible).map(f => f.featureId);
	// extract default decisions from conditionalVariantValues
	return conditionalVariantValues
		.filter(cvv => (
			cvv.id === 'DEFAULT_VALUE' &&
			cvv.type === 'AdditionalAttribute' &&
			cvv.value === '1' &&
			visibleFeatures.includes(cvv.conditions[0]?.featureId) && // only use visible features as default
			cvv.conditions[0]?.valueId !== '')
		).map(ccv =>
			spcExpliciteChoiceDecision(ccv.conditions[0].featureId, ccv.conditions[0].valueId)
		);
}
